export default "__VITE_PUBLIC_ASSET__e59697e6__"